var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTasks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.11766 4.7647C1.63035 4.7647 1.23531 5.15974 1.23531 5.64705V21.8823C1.23531 22.3697 1.63035 22.7647 2.11766 22.7647H21.8824C22.3697 22.7647 22.7647 22.3697 22.7647 21.8823V5.64705C22.7647 5.15974 22.3697 4.7647 21.8824 4.7647H17.6471V3.70587H21.8824C22.9544 3.70587 23.8235 4.57497 23.8235 5.64705V21.8823C23.8235 22.9544 22.9544 23.8235 21.8824 23.8235H2.11766C1.04558 23.8235 0.176483 22.9544 0.176483 21.8823V5.64705C0.176483 4.57497 1.04558 3.70587 2.11766 3.70587H6.35295V4.7647H2.11766Z",
    fill: "inherit"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.1173 9.48744C8.3354 9.68218 8.35434 10.0168 8.15961 10.2349L5.6386 13.0585C5.53816 13.171 5.3945 13.2353 5.24369 13.2353C5.09288 13.2353 4.94923 13.171 4.84878 13.0585L3.84038 11.9291C3.64565 11.711 3.66459 11.3763 3.88269 11.1816C4.10079 10.9868 4.43546 11.0058 4.6302 11.2239L5.24369 11.911L7.36979 9.52976C7.56453 9.31165 7.8992 9.29271 8.1173 9.48744Z",
    fill: "inherit"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.1173 15.8404C8.3354 16.0351 8.35434 16.3698 8.15961 16.5879L5.6386 19.4114C5.53816 19.5239 5.3945 19.5882 5.24369 19.5882C5.09288 19.5882 4.94923 19.5239 4.84878 19.4114L3.84038 18.282C3.64565 18.0639 3.66459 17.7292 3.88269 17.5345C4.10079 17.3398 4.43546 17.3587 4.6302 17.5768L5.24369 18.2639L7.36979 15.8827C7.56453 15.6646 7.8992 15.6456 8.1173 15.8404Z",
    fill: "inherit"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4706 10.5882C11.4706 10.2959 11.7076 10.0588 12 10.0588H19.7647C20.0571 10.0588 20.2941 10.2959 20.2941 10.5882C20.2941 10.8806 20.0571 11.1177 19.7647 11.1177H12C11.7076 11.1177 11.4706 10.8806 11.4706 10.5882Z",
    fill: "inherit"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4706 14.8235C11.4706 14.5312 11.7076 14.2941 12 14.2941H19.7647C20.0571 14.2941 20.2941 14.5312 20.2941 14.8235C20.2941 15.1159 20.0571 15.353 19.7647 15.353H12C11.7076 15.353 11.4706 15.1159 11.4706 14.8235Z",
    fill: "inherit"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4706 19.0588C11.4706 18.7664 11.7076 18.5294 12 18.5294H19.7647C20.0571 18.5294 20.2941 18.7664 20.2941 19.0588C20.2941 19.3512 20.0571 19.5882 19.7647 19.5882H12C11.7076 19.5882 11.4706 19.3512 11.4706 19.0588Z",
    fill: "inherit"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.31763 1.23531C9.22017 1.23531 9.14116 1.31432 9.14116 1.41178V1.83531C9.14116 2.12769 8.90414 2.36472 8.61175 2.36472H7.05881C6.96135 2.36472 6.88234 2.44373 6.88234 2.54119V5.64707C6.88234 5.74453 6.96135 5.82354 7.05881 5.82354H16.9412C17.0386 5.82354 17.1176 5.74453 17.1176 5.64707V2.54119C17.1176 2.44373 17.0386 2.36472 16.9412 2.36472H15.3882C15.0958 2.36472 14.8588 2.12769 14.8588 1.83531V1.41178C14.8588 1.31431 14.7798 1.23531 14.6823 1.23531H9.31763ZM8.08681 1.30589C8.14052 0.673227 8.67107 0.176483 9.31763 0.176483H14.6823C15.3289 0.176483 15.8595 0.673227 15.9132 1.30589H16.9412C17.6234 1.30589 18.1765 1.85896 18.1765 2.54119V5.64707C18.1765 6.3293 17.6234 6.88237 16.9412 6.88237H7.05881C6.37658 6.88237 5.82352 6.32931 5.82352 5.64707V2.54119C5.82352 1.85896 6.37658 1.30589 7.05881 1.30589H8.08681Z",
    fill: "inherit"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.11766 4.7647C1.63035 4.7647 1.23531 5.15974 1.23531 5.64705V21.8823C1.23531 22.3697 1.63035 22.7647 2.11766 22.7647H21.8824C22.3697 22.7647 22.7647 22.3697 22.7647 21.8823V5.64705C22.7647 5.15974 22.3697 4.7647 21.8824 4.7647H17.6471V3.70587H21.8824C22.9544 3.70587 23.8235 4.57497 23.8235 5.64705V21.8823C23.8235 22.9544 22.9544 23.8235 21.8824 23.8235H2.11766C1.04558 23.8235 0.176483 22.9544 0.176483 21.8823V5.64705C0.176483 4.57497 1.04558 3.70587 2.11766 3.70587H6.35295V4.7647H2.11766Z",
    fill: "inherit"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasks);
export default __webpack_public_path__ + "static/media/Tasks.549286abf4fa2cdf0945404437e2191a.svg";
export { ForwardRef as ReactComponent };